import { render, staticRenderFns } from "./bindAdminDialog.vue?vue&type=template&id=50a9481a&"
import script from "./bindAdminDialog.vue?vue&type=script&lang=js&"
export * from "./bindAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindAdminDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports